<template>
    <div>
        <v-list dense tile>
            <v-list-item-group v-model="item" color="primary">
                <v-list-item v-for="(cat, index) in ingredientCategories" :key="(cat.id)">
                    <template v-if="editOffset !== index">

                        <v-list-item-content class="pa-0" @click="startEditing(index)">
                            {{cat.name}}
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="deleteIngredientCategory(cat.id)">mdi-delete</v-icon>
                        </v-list-item-icon>

                    </template>

                    <template v-if="editOffset===index">
                        <v-list-item-content class="pa-0" @keydown.esc="cancelEditing" @keydown.enter="updateIngredientCategory(cat.id)">
                            <v-text-field dense v-model="tempValue" required> {{ tempValue }}
                            </v-text-field>
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="updateIngredientCategory(cat.id)">mdi-content-save</v-icon>
                            <v-icon medium @click="cancelEditing">mdi-close-circle</v-icon>
                        </v-list-item-icon>
                    </template>
                </v-list-item>

                <v-list-item v-for="(input, index) in inputs" :key="index">
                    <v-list-item-content class="pa-0">
                        <v-text-field dense v-model="input.one" required> {{ input.one }}
                        </v-text-field>
                    </v-list-item-content>
                    <v-list-item-icon justify="space-around">
                        <span class="group">                  
                            <v-icon medium @click="createIngredientCategory(index)" :disabled="input.one === ''">mdi-plus-circle</v-icon> 
                            <v-icon medium @click="deleteRow(index)">mdi-close-circle</v-icon>  
                        </span>                    
                    </v-list-item-icon>
                </v-list-item>
            </v-list-item-group>
        </v-list>



        <div class="text-center pt-2">
            <v-btn color="secondary" class="black--text" :disabled="disableAdd" small @click="addRow">إضافة تصنيف</v-btn>
        </div>

    </div>
</template>

<script>
    import {
        GET_INGREDIENT_CATEGORIES,
        ADD_INGREDIENT_CATEGORY,
        UPDATE_INGREDIENT_CATEGORY,
        DELETE_INGREDIENT_CATEGORY 
    } from '../graphql/IngredientCategories'

    export default {
        data() {
            return {
                item: -1,
                ingredientCategories: '',
                disableAdd: false,
                editOffset: -1,
                tempValue: null,
                inputs: []
            }
        },
        apollo: {
            ingredientCategories: {
                query: GET_INGREDIENT_CATEGORIES
            }
        },
        methods: {
            addRow() {
                this.disableAdd = true
                this.inputs.push({
                    one: ''
                })
            },
            deleteRow(index) {
                this.disableAdd = false
                this.inputs.splice(index, 1)
            },
            startEditing: function (index) {
                this.disableAdd = true
                this.editOffset = index;
                this.tempValue = this.ingredientCategories[index].name
            },
            cancelEditing: function () {
                this.disableAdd = false
                this.editOffset = -1;
                this.tempValue = null;
            },
            createIngredientCategory(index) {
                this.$apollo.mutate({
                    mutation: ADD_INGREDIENT_CATEGORY,
                    variables: {
                        name: this.inputs[index].one,
                    },
                    update: (cache, {data: {createIngredientCategory} }) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_INGREDIENT_CATEGORIES
                        })

                        // Create updated data
                        data.ingredientCategories.push(createIngredientCategory)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_INGREDIENT_CATEGORIES,
                            data
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        createIngredientCategory: {
                            __typename: 'IngredientCategory',
                            name: this.inputs[index].one
                        }
                    }

                }).then(({
                    data
                }) => {
                    this.disableAdd = false
                    this.inputs.splice(index, 1)
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            updateIngredientCategory(id) {
                this.$apollo.mutate({
                    mutation: UPDATE_INGREDIENT_CATEGORY,
                    variables: {
                        id: id,
                        name: this.tempValue,
                    },
                    update: (cache, {data: { updateIngredientCategory }}) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_INGREDIENT_CATEGORIES
                        })

                        let index = data.ingredientCategories.findIndex(category => category.id === updateIngredientCategory.id) 

                        let updatedIngredientCategories = [
                            ...data.ingredientCategories.slice(0, index),
                            updateIngredientCategory,
                            ...data.ingredientCategories.slice(index + 1)
                        ]
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_INGREDIENT_CATEGORIES,
                            data: updatedIngredientCategories
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        updateIngredientCategory: {
                            __typename: 'IngredientCategory',
                            name: this.tempValue
                        }
                    }

                }).then(({data}) => {
                    this.disableAdd = false
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            deleteIngredientCategory(id) {
                this.$apollo.mutate({
                    mutation: DELETE_INGREDIENT_CATEGORY,
                    variables: {
                        id: id
                    },
                    update: (cache, {data: { deleteIngredientCategory }}) => {
                        //First read the query you want to update
                        const data = cache.readQuery({
                            query: GET_INGREDIENT_CATEGORIES
                        })

                        let index = data.ingredientCategories.findIndex(category => category.id === deleteIngredientCategory.id) 

                        data.ingredientCategories.splice(index, 1)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_INGREDIENT_CATEGORIES,
                            data
                        })
                    },

                }).then(({data}) => {
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>

</style>